export default "__VITE_ASSET__17ed8f24__"